import React, { useEffect, useState } from "react";
import api from "./api";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    role: "user",
  });
  const [editingUserId, setEditingUserId] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => { fetchUsers(); }, []);

  const fetchUsers = async () => {
    try {
      const res = await api.get("/users");
      setUsers(res.data);
    } catch {
      setError("Nie udało się pobrać użytkowników.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Na pewno usunąć tego użytkownika?")) return;
    try {
      await api.delete(`/users/${id}`);
      fetchUsers();
    } catch {
      alert("Błąd podczas usuwania.");
    }
  };

  const handleEdit = (user) => {
    setEditingUserId(user.id);
    setForm({
      username: user.username || "",
      first_name: user.first_name || "",
      last_name: user.last_name || "",
      email: user.email,
      password: "",
      role: user.role,
    });
  };

  const handleCancelEdit = () => {
    setEditingUserId(null);
    setForm({
      username: "",
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      role: "user",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingUserId) {
        await api.put(`/users/${editingUserId}`, form);
      } else {
        await api.post("/users", form);
      }
      handleCancelEdit();
      fetchUsers();
    } catch {
      alert("Nie udało się zapisać użytkownika.");
    }
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4">👤 Zarządzanie użytkownikami</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit} className="row g-2 align-items-end mb-4">
        <div className="col-12 col-md-2">
          <input
            type="text"
            placeholder="Nazwa użytkownika"
            className="form-control"
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            required
          />
        </div>
        <div className="col-12 col-md-2">
          <input
            type="text"
            placeholder="Imię"
            className="form-control"
            value={form.first_name}
            onChange={(e) => setForm({ ...form, first_name: e.target.value })}
            required
          />
        </div>
        <div className="col-12 col-md-2">
          <input
            type="text"
            placeholder="Nazwisko"
            className="form-control"
            value={form.last_name}
            onChange={(e) => setForm({ ...form, last_name: e.target.value })}
            required
          />
        </div>
        <div className="col-12 col-md-3">
          <input
            type="email"
            placeholder="Email"
            className="form-control"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
        </div>
        <div className="col-12 col-md-2">
          <input
            type="password"
            placeholder={editingUserId ? "Nowe hasło (opcjonalnie)" : "Hasło"}
            className="form-control"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required={!editingUserId}
          />
        </div>
        <div className="col-6 col-md-1">
          <select
            className="form-select"
            value={form.role}
            onChange={(e) => setForm({ ...form, role: e.target.value })}
          >
            <option value="user">user</option>
            <option value="admin">admin</option>
          </select>
        </div>
        <div className="col-6 col-md-1 d-flex gap-1">
          <button className="btn btn-primary w-100" type="submit">
            {editingUserId ? "💾" : "➕"}
          </button>
          {editingUserId && (
            <button type="button" className="btn btn-secondary" onClick={handleCancelEdit}>
              ✕
            </button>
          )}
        </div>
      </form>

      <div className="table-responsive">
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th>Imię i nazwisko</th>
              <th>Nazwa użytkownika</th>
              <th>Email</th>
              <th>Rola</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.first_name} {u.last_name}</td>
                <td>{u.username}</td>
                <td>{u.email}</td>
                <td>{u.role}</td>
                <td className="d-flex gap-2">
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handleEdit(u)}
                    title="Edytuj"
                  >
                    ✏️
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(u.id)}
                    title="Usuń"
                  >
                    🗑
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminUsers;
